module.exports = "https://bin.bnbstatic.com/_next/static/images/stefano-0dacb9793e69378d2eddab69bd4f1048.jpg";